import { Theme } from '@mui/material'
import { UserSettings, EUserRole } from '@professocialApi/professocial-core-frontend-api/'

import {
  NetworkPage,
  ScreenEnum,
  ViewEnum,
  PostingTemplate,
  SocialNetworkLicensePermissions,
  DisplayMode, Languages, GeneralPostingOptions, GeneralOptions, RegistrationCustomerData,
} from './commonTypes'
import {
  DeferredPost,
  NetworkType,
  FacebookPage,
  FacebookPost,
  InstagramPost,
  PostTemplate,
  PublishedPostWithPostContent,
  LinkedInPage
} from '@3m5/sm_publish-frontend-api/models'
import { FilterType } from '@professocial/professocialPosting/src/shared/types/types'
import { LinkedInPost } from '@3m5/sm_publish-frontend-api/models/LinkedInPost'

export type LoginConfiguration = {
    theme?: Theme
    registrationCustomerData?: RegistrationCustomerData
}

export type ExternalLinksConfiguration = {
    theme?: Theme
    data?: any
}

export type StatisticConfiguration = {
    theme?: Theme
    user?: any
    networkPage?: NetworkPage
    licensePermissions?: SocialNetworkLicensePermissions
}

export type AccountConfiguration = {
    theme?: Theme
    user?: any
    language?: Languages[]
}

export type CoreConfiguration = {
    theme?: Theme
    user?: UserSettings
    language?: Languages[]
    logo?: string
    footerLogo?: string
    developmentSystem?: boolean
    externalLinks?: ExternalLinksConfiguration
}

export type TopicConfiguration = {
    theme?: Theme
    networkPage?: NetworkPage
    integrateImages?: boolean
    editMode?: DisplayMode
    editable?: boolean
    initialValueDropdown?: boolean
    licensePermissions?: SocialNetworkLicensePermissions
}

export type PostConfiguration = {
    theme?: Theme
    userRole?: EUserRole
    size?: ScreenEnum
    view?: ViewEnum
    filterType?: FilterType
    networkPageId?: string
    networkUserId?: string
    networkType?: NetworkType
    elementSize?: number
    facebookPost?: FacebookPost
    instagramPost?: InstagramPost
    linkedInPost?: LinkedInPost
    linkedInPage?: LinkedInPage
    googleMyBusinessPost?: any
    posting?: PostingTemplate
    post?: PostTemplate
    onEditFeed?: (post: any) => void
    deferredPost?: DeferredPost
    publishedPost?: PublishedPostWithPostContent
}

export type FacebookSettingsConfiguration = {
    theme?: Theme
    user?: UserSettings
    facebookPage?: FacebookPage
}

export type PostingConfiguration = {
    theme?: Theme
    user?: any
    networkUserId?: string
    generalPostingOptions: GeneralPostingOptions
    networkPage?: NetworkPage
    licensePermissions: SocialNetworkLicensePermissions
    post?: any
    templateId?: string
}

export type NetworkContentConfiguration = {
    theme?: Theme
    user?: any
    generalOptions?: GeneralOptions
    networkPage?: NetworkPage
    networkType?: NetworkType
    defaults?: ConfigurationDefaults
}

export type ConfigurationDefaults = {
    networkType?: NetworkType
}
